import { Typography } from "@mui/material";
import React from "react";

const Labels = ({ text }) => {
  return <Typography sx={{ mb: 0.5 }}>{text}</Typography>;
};

export default Labels;
